import ApiService from "./api.service"

export const ServiceService = {
  list() {
    return ApiService.get(`services`)
  },
}
